import { useUnreadInboxCount } from "../../hooks/useUnreadInboxCount";
import { Text } from "../../../../components/common/typography";

const MAX_DISPLAYED = 9;

/**
 * Small red dot + count to overlay the bell icon. Renders nothing when
 * unread count is 0. Caller positions it absolutely inside a `relative`
 * parent (the bell button).
 */
export function InboxBellBadge() {
  const { data } = useUnreadInboxCount();
  const count = data?.count ?? 0;
  if (count <= 0) return null;

  return (
    <span
      aria-label={`${count} unread notification${count === 1 ? "" : "s"}`}
      className="pointer-events-none absolute -right-1 -top-1 inline-flex min-w-[18px] items-center justify-center rounded-full bg-accentError px-1 text-white border border-bgWhite"
      style={{ height: 18 }}
    >
      <Text variant="bodyXsBold" tone="inherit" inline>
        {count > MAX_DISPLAYED ? `${MAX_DISPLAYED}+` : count}
      </Text>
    </span>
  );
}
